import ReactApp from './ReactApp';

const App = () => {
  return (
    <div className="App">
      <ReactApp />
    </div>
  );
}

export default App;
